import React from 'react'
import PropTypes from 'prop-types'
import { Pagination } from '@CommonComponents/buttons'
import { useStateValue } from '@State'
import { GradebookHeaders } from './GradebookHeaders'
import { StudentNames } from './StudentNames'
import { StudentEntries } from './StudentEntries'

export const GradebookTable = ({ changePage }) => {
  const [currentState] = useStateValue()
  const { totalStudents, entries, activities } = currentState.gradebook
  const lower = currentState.limit * currentState.page - currentState.limit + 1
  const upper =
    totalStudents >= currentState.limit * currentState.page
      ? currentState.limit * currentState.page
      : totalStudents
  return (
    <div>
      <div id="gradebook_table_container">
        <div className="student_count">
          Now showing {lower} - {upper} of {totalStudents} students
        </div>
        <div className="gradebook_table_wrapper">
          <table className="gradebook_table calculating-dimensions">
            <tbody>
              <tr className="gradebook_top">
                <td>
                  <div id="gradebook_top_left">
                    <GradebookHeaders
                      activities={[]}
                      coursenum={currentState.coursenum}
                      section="left"
                    />
                  </div>
                </td>
                <td>
                  <div id="gradebook_top_right">
                    <GradebookHeaders
                      activities={activities}
                      coursenum={currentState.coursenum}
                      section="right"
                    />
                  </div>
                </td>
              </tr>
              <tr id="gradebook_bottom">
                <td>
                  <div id="gradebook_bottom_left">
                    <StudentNames
                      entries={entries}
                      coursenum={currentState.coursenum}
                    />
                  </div>
                </td>
                <td>
                  <div id="gradebook_bottom_right">
                    <StudentEntries activities={activities} entries={entries} />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>



        <Pagination
          currentPage={currentState.page}
          rate={currentState.limit}
          total={totalStudents}
          setCurrentPage={changePage}
        />
      </div>
    </div>
  )
}

GradebookTable.propTypes = {
  changePage: PropTypes.func.isRequired,
}
